import type { Locale } from '@packages/config';

export const getCmsDataCacheKey = (prefix: string, locale: Locale): string => `${prefix}-${locale}`;
